import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: row;

    width: 100%;
    height: 100%;
    align-items: center;
`;
